// @flow

export function getCategoryColor(id: number) {
  return '#961DA0';
}



// WEBPACK FOOTER //
// ./src/utils.js